module.exports = __webpack_public_path__ + "img/charging.2179688c.gif";